import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DialogOverlay,
  DialogOverlayFooter,
  DialogOverlayActions,
  Button,
  Paragraph,
  H2,
  Separator,
  Image,
} from '@fs/zion-ui'
import { i18n } from '@fs/zion-locale'
import { DocumentBasic } from '@fs/zion-icon'
import { getPersonSurname } from '@fs/zion-sls'
import { getPrimaryOrFirstPerson } from '../../utils/utils'
import handleClickRecordDetails from '../../../../utils/handleClickRecordDetails'
import getPlaceName from '../../../../../shared/services/standards/places'
import Tip from '../../../../components/tip/Tip'
import ThankYouOverlay from '../../../../components/sharedReviewComponents/ReviewCompletionDialog/images/ThankYouOverlay.png'

export default function FinishedOverlay({
  finishedOverlay,
  currentTask,
  goBackToGive,
  handleContinue,
  placeCode,
  hasImagePermission,
}) {
  const [t] = useTranslation()
  const continueButtonRef = useRef()
  const [placeName, setPlaceName] = useState('') // Current name field
  const primaryPerson = getPrimaryOrFirstPerson(currentTask)
  const surname = getPersonSurname(primaryPerson)

  useEffect(() => {
    async function getPlaceData() {
      const { displayName } = await getPlaceName(placeCode, i18n.language)
      setPlaceName(displayName.name)
    }
    if (placeCode) getPlaceData()
  }, [placeCode])

  return (
    <DialogOverlay {...finishedOverlay} focusRef={continueButtonRef}>
      <Image src={ThankYouOverlay} alt={t('completion-dialog.thank-you', 'Thank you!')} />
      <Separator size="xxs" />
      <H2 size="H5">
        {surname &&
          placeName &&
          t('family-review.finishedOverlay.content', 'You just helped the {surname} Family from {placeName}!', {
            surname,
            placeName,
          })}
        {!surname &&
          placeName &&
          t('family-review.finishedOverlay.contentA', 'You just helped a family from {placeName}!', {
            placeName,
          })}
        {surname &&
          !placeName &&
          t('family-review.finishedOverlay.contentB', 'You just helped the {surname} Family!', {
            surname,
          })}
        {!surname && !placeName && t('family-review.finishedOverlay.contentC', 'You just helped a family!')}
      </H2>
      <Separator size="xxs" />
      {primaryPerson?.id && hasImagePermission && (
        <Tip
          primaryText={
            <Paragraph size="sm">
              {t(
                'family-review.finished-overlay.question.heading',
                'Do you want to explore this record in more detail?'
              )}
            </Paragraph>
          }
          listPrimaryText={
            <Button
              emphasis="low"
              Icon={DocumentBasic}
              onClick={() => handleClickRecordDetails(primaryPerson?.id)}
              data-testid="record-details"
              linkName="Finished Overlay Record Details"
            >
              {t('navigation.finalPage.details-button', 'GO TO RECORD DETAILS')}
            </Button>
          }
        />
      )}
      <DialogOverlayFooter>
        <Paragraph size="sm">
          <strong>
            {t('family-review.finishedOverlay.content2', 'Do you want to continue with Indexing Review?')}
          </strong>
        </Paragraph>
        <DialogOverlayActions>
          <Button linkName="Finished Overlay Back to Give" onClick={goBackToGive} data-testid="Maybe Later">
            {t('finished-overlay.later-btn', 'Maybe later')}
          </Button>
          <Button
            ref={continueButtonRef}
            linkName="Finished Overlay Continue"
            onClick={handleContinue}
            emphasis="high"
            data-testid="continue-button"
          >
            {t('finished-overlay.continue-btn', 'Continue')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
